export const TYPE_HIME_NOTIFY_APPKF = 1;
export const TYPE_USER_NOTIFY_SMS = 2;
export const TYPE_USER_NOTIFY_WEB = 3;
export const TYPE_USER_NOTIFY_WEB_RESV = 4;
export const TYPE_USER_NETRESV_CREATE = 11; // ネット予約作成
export const TYPE_USER_NETRESV_DELETE = 12; // ネット予約確定前キャンセル
export const TYPE_HIMED_LINE_CONTACT = 21; // 女子・ドライバーからのLINE登録受信
export const TYPE_USER_LINE_CONTACT = 24; // LINEからの問い合わせ
export const TYPE_USER_LINE_RESV = 25; // UserからのLINE予約受信
export const TYPE_SYSTEM_SENDFALURE = 31; // システムからのNotify送信失敗の受信
export const TYPE_SYSTEM_SENDFALURE_LINE = 32; // システムからのLINE送信失敗の受信
